import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ShiftListPane } from '@apps/web/components/dashboard/shift_list_pane';
import { useDeepLinkOrganization } from '@apps/web/hooks/use_deep_link_organization';

const shiftSearchSchema = z.object({
    date: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    status: z.enum(['open', 'needs_coverage', 'needs_attention']).optional(),
    clientIds: z.array(z.string().uuid()).optional(),
    calloutShiftId: z.string().optional(),
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

export const Route = createFileRoute('/_app/(main)/shifts/$shift-id')({
    component: ShiftDetailsPage,
    validateSearch: shiftSearchSchema,
    head: () => ({
        meta: [
            {
                title: 'Shift Details | Phoebe',
            },
        ],
    }),
});

function ShiftDetailsPage() {
    const { 'shift-id': shiftId } = Route.useParams();
    const {
        date,
        from,
        to,
        status,
        clientIds,
        calloutShiftId,
        organizationId: deepLinkOrganizationId,
        mode: deepLinkMode,
    } = Route.useSearch();
    const { isWaitingForDeepLinkOrganization } = useDeepLinkOrganization(
        deepLinkOrganizationId,
        deepLinkMode,
    );

    if (isWaitingForDeepLinkOrganization) {
        return null;
    }

    return (
        <ShiftListPane
            initialDate={date}
            initialFrom={from}
            initialTo={to}
            initialStatus={status}
            initialClientIds={clientIds}
            selectedShiftId={shiftId}
            selectedShiftPathId={shiftId}
            calloutShiftId={calloutShiftId}
        />
    );
}
